var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgNonBillable16 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3765_202503)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.5 8H10.5V9H11.5V8Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 8H4.5V9H7V8Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5 6H4.5V7H8.5V6Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 4H4.5V5H10.5V4Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 1H3.5C3.23486 1.00026 2.98066 1.10571 2.79319 1.29319C2.60571 1.48066 2.50026 1.73486 2.5 2V13.0168L3.5 11.9976V2H12.5V2.82452L13.4838 1.8218C13.4476 1.62292 13.3517 1.43814 13.2068 1.29323C13.0193 1.10576 12.7651 1.0003 12.5 1ZM2.64645 14.8536C2.6368 14.8439 2.62759 14.8339 2.61883 14.8236L5.29075 12.1003C5.33164 12.128 5.36846 12.1616 5.4 12.2L6.5 13.6665L7.6 12.2C7.64856 12.1409 7.70962 12.0933 7.77878 12.0606C7.84795 12.0279 7.9235 12.0109 8 12.0109C8.0765 12.0109 8.15205 12.0279 8.22122 12.0606C8.29038 12.0933 8.35144 12.1409 8.4 12.2L9.5 13.6665L10.6 12.2C10.6486 12.1409 10.7096 12.0933 10.7788 12.0606C10.8479 12.0279 10.9235 12.0109 11 12.0109C11.0765 12.0109 11.1521 12.0279 11.2212 12.0606C11.2904 12.0933 11.3514 12.1409 11.4 12.2L12.5 13.6665V4.7524L13.5 3.73317V14.5C13.5 14.6326 13.4473 14.7598 13.3536 14.8536C13.2598 14.9473 13.1326 15 13 15H12.5C12.4224 15 12.3458 14.982 12.2764 14.9473C12.2069 14.9125 12.1466 14.8621 12.1 14.8L11 13.3335L9.9 14.8C9.85144 14.8591 9.79038 14.9067 9.72122 14.9394C9.65205 14.9721 9.5765 14.9891 9.5 14.9891C9.4235 14.9891 9.34795 14.9721 9.27878 14.9394C9.20962 14.9067 9.14856 14.8591 9.1 14.8L8 13.3335L6.9 14.8C6.85144 14.8591 6.79038 14.9067 6.72122 14.9394C6.65205 14.9721 6.5765 14.9891 6.5 14.9891C6.4235 14.9891 6.34795 14.9721 6.27878 14.9394C6.20962 14.9067 6.14856 14.8591 6.1 14.8L5 13.3335L3.75 14.5C3.65005 14.3001 3.60313 14.4622 3.5624 14.6029C3.54201 14.6733 3.52317 14.7384 3.5 14.75C3.47029 14.7649 3.43444 14.8128 3.39706 14.8628L3.39706 14.8628C3.3471 14.9296 3.29441 15 3.25 15H3C2.86739 15 2.74021 14.9473 2.64645 14.8536Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 2.5L2 15.75",
    stroke: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3765_202503"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgNonBillable16);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/non-billable-16.1c4d59a46ac3edc7bfedad056fbee8a3.svg";